import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateSchedule = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 498.09 493.26",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{fill:#ebf3ff;}.d{fill:#fafcff;}.e{fill:#9ec5ff;}.f{fill:#b5c5ea;}.g{fill:#dcebfe;}.h{fill:#222d60;}.i{opacity:.15;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "d",
				cx: 246.8,
				cy: 246.79,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					className: "c",
					x: 143.65,
					y: 85.86,
					width: 354.43,
					height: 330.03,
					rx: 5,
					ry: 5
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
					className: "g",
					x: 178.09,
					y: 121.12,
					width: 285.57,
					height: 47.09
				}), /* @__PURE__ */ _jsx("rect", {
					className: "f",
					x: 178.09,
					y: 121.12,
					width: 80.55,
					height: 47.09
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "d",
					d: "M380.88,257.66c0,17.06-7.11,32.44-18.54,43.36-10.76,10.31-25.38,16.64-41.46,16.64s-30.68-6.31-41.46-16.62c-11.43-10.92-18.54-26.31-18.54-43.38,0-33.13,26.85-60,60-60s60,26.87,60,60Z"
				}), /* @__PURE__ */ _jsx("path", {
					className: "f",
					d: "M362.33,301.02c-10.76,10.31-25.38,16.64-41.46,16.64s-30.68-6.31-41.46-16.62c2.65-17.24,15.79-30.99,32.68-34.58-8.87-3.5-15.17-12.14-15.17-22.28,0-13.23,10.72-23.95,23.95-23.95s23.95,10.72,23.95,23.95c0,10.14-6.3,18.78-15.19,22.28,16.89,3.59,30.03,17.35,32.69,34.56Z"
				})] }),
				/* @__PURE__ */ _jsx("rect", {
					className: "f",
					x: 218.8,
					y: 376.76,
					width: 204.14,
					height: 9.71,
					rx: 4.86,
					ry: 4.86
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("rect", {
						className: "f",
						x: 310.43,
						y: 349.55,
						width: 22.7,
						height: 9.71,
						rx: 4.86,
						ry: 4.86
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "f",
						x: 261.44,
						y: 349.55,
						width: 40.84,
						height: 9.71,
						rx: 4.86,
						ry: 4.86
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "f",
						x: 339.46,
						y: 349.55,
						width: 40.84,
						height: 9.71,
						rx: 4.86,
						ry: 4.86
					})
				] }),
				/* @__PURE__ */ _jsx("rect", {
					className: "c",
					x: 197.94,
					y: 139.81,
					width: 40.84,
					height: 9.71,
					rx: 4.86,
					ry: 4.86
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "i",
						d: "M184.36,243.05v-3.45c0-4.59-3.72-8.32-8.32-8.32H61.07c-4.59,0-8.32,3.72-8.32,8.32v3.45h0v116.22H184.36v-116.22h0Z"
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "g",
						x: 46.43,
						y: 237.17,
						width: 131.61,
						height: 116.22
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "e",
						d: "M54.75,225.4h114.97c4.59,0,8.32,3.73,8.32,8.32v33.57H46.43v-33.57c0-4.59,3.73-8.32,8.32-8.32Z"
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "e",
							d: "M80.41,293.09h-7.7v-6.94c0-.65-.58-1.17-1.3-1.17s-1.3,.52-1.3,1.17v6.94h-7.7c-.72,0-1.3,.52-1.3,1.17s.58,1.17,1.3,1.17h7.7v6.94c0,.65,.58,1.17,1.3,1.17s1.3-.52,1.3-1.17v-6.94h7.7c.72,0,1.3-.52,1.3-1.17s-.58-1.17-1.3-1.17Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "e",
							d: "M121.23,293.09h-7.7v-6.94c0-.65-.58-1.17-1.3-1.17s-1.3,.52-1.3,1.17v6.94h-7.7c-.72,0-1.3,.52-1.3,1.17s.58,1.17,1.3,1.17h7.7v6.94c0,.65,.58,1.17,1.3,1.17s1.3-.52,1.3-1.17v-6.94h7.7c.72,0,1.3-.52,1.3-1.17s-.58-1.17-1.3-1.17Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "e",
							d: "M162.05,293.09h-7.7v-6.94c0-.65-.58-1.17-1.3-1.17s-1.3,.52-1.3,1.17v6.94h-7.7c-.72,0-1.3,.52-1.3,1.17s.58,1.17,1.3,1.17h7.7v6.94c0,.65,.58,1.17,1.3,1.17s1.3-.52,1.3-1.17v-6.94h7.7c.72,0,1.3-.52,1.3-1.17s-.58-1.17-1.3-1.17Z"
						})
					] }),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "e",
							d: "M80.41,327.57h-7.7v-6.94c0-.65-.58-1.17-1.3-1.17s-1.3,.52-1.3,1.17v6.94h-7.7c-.72,0-1.3,.52-1.3,1.17s.58,1.17,1.3,1.17h7.7v6.94c0,.65,.58,1.17,1.3,1.17s1.3-.52,1.3-1.17v-6.94h7.7c.72,0,1.3-.52,1.3-1.17s-.58-1.17-1.3-1.17Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "e",
							d: "M121.23,327.57h-7.7v-6.94c0-.65-.58-1.17-1.3-1.17s-1.3,.52-1.3,1.17v6.94h-7.7c-.72,0-1.3,.52-1.3,1.17s.58,1.17,1.3,1.17h7.7v6.94c0,.65,.58,1.17,1.3,1.17s1.3-.52,1.3-1.17v-6.94h7.7c.72,0,1.3-.52,1.3-1.17s-.58-1.17-1.3-1.17Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "e",
							d: "M162.05,327.57h-7.7v-6.94c0-.65-.58-1.17-1.3-1.17s-1.3,.52-1.3,1.17v6.94h-7.7c-.72,0-1.3,.52-1.3,1.17s.58,1.17,1.3,1.17h7.7v6.94c0,.65,.58,1.17,1.3,1.17s1.3-.52,1.3-1.17v-6.94h7.7c.72,0,1.3-.52,1.3-1.17s-.58-1.17-1.3-1.17Z"
						})
					] }),
					/* @__PURE__ */ _jsx("rect", {
						className: "g",
						x: 66.91,
						y: 238.5,
						width: 90.65,
						height: 10.99,
						rx: 5.5,
						ry: 5.5
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "h",
						d: "M177.09,261.66c-2.05,0-2.77,2.19-3.46,4.31-.28,.85-.78,2.38-1.2,2.75-.42-.36-.92-1.9-1.2-2.75-.69-2.12-1.42-4.31-3.46-4.31s-2.77,2.19-3.46,4.31c-.27,.85-.78,2.38-1.19,2.75-.42-.36-.92-1.9-1.2-2.75-.7-2.12-1.42-4.31-3.46-4.31s-2.77,2.19-3.46,4.31c-.27,.85-.78,2.38-1.19,2.75-.42-.36-.92-1.9-1.2-2.75-.7-2.12-1.42-4.31-3.46-4.31s-2.77,2.19-3.46,4.31c-.27,.85-.78,2.38-1.2,2.75-.41-.36-.92-1.9-1.19-2.75-.7-2.12-1.42-4.31-3.46-4.31s-2.76,2.19-3.46,4.31c-.28,.85-.78,2.38-1.2,2.75-.41-.36-.92-1.9-1.19-2.75-.7-2.12-1.42-4.31-3.46-4.31s-2.76,2.19-3.46,4.31c-.28,.84-.77,2.35-1.19,2.73-.04-.03-.08-.06-.12-.11h0s-.05-.07-.07-.1c-.37-.57-.78-1.79-1.01-2.52-.39-1.2-.8-2.42-1.44-3.25-.5-.66-1.14-1.09-2.05-1.09-2.05,0-2.76,2.19-3.46,4.3-.28,.85-.78,2.38-1.2,2.74-.04-.04-.09-.1-.14-.16-.38-.55-.79-1.81-1.03-2.55-.44-1.33-.88-2.69-1.66-3.51-.47-.51-1.05-.83-1.83-.83-2.05,0-2.76,2.19-3.46,4.3-.28,.85-.78,2.37-1.2,2.74-.41-.41-.89-1.88-1.17-2.71-.48-1.46-.97-2.95-1.9-3.74-.43-.37-.94-.6-1.6-.6-2.04,0-2.76,2.19-3.46,4.3-.28,.85-.78,2.38-1.2,2.74-.42-.36-.92-1.9-1.2-2.74-.7-2.12-1.41-4.3-3.46-4.3s-2.76,2.19-3.46,4.3c-.28,.85-.78,2.38-1.2,2.74-.42-.36-.92-1.9-1.2-2.74-.7-2.12-1.41-4.3-3.46-4.3s-2.76,2.19-3.46,4.3c-.28,.85-.78,2.38-1.2,2.74-.42-.36-.92-1.9-1.2-2.74-.7-2.12-1.41-4.3-3.46-4.3s-2.76,2.19-3.46,4.3c-.28,.85-.78,2.38-1.2,2.74-.42-.36-.92-1.9-1.2-2.74-.69-2.12-1.41-4.3-3.46-4.3s-2.76,2.19-3.46,4.3c-.28,.85-.78,2.38-1.2,2.74-.42-.36-.92-1.9-1.2-2.74-.7-2.12-1.41-4.3-3.46-4.3s-2.76,2.19-3.46,4.3c-.28,.85-.78,2.38-1.2,2.74-.42-.36-.92-1.9-1.2-2.74-.69-2.12-1.41-4.3-3.46-4.3v2.13s-.07-.01-.08-.02c.43,.22,.98,1.9,1.28,2.8,.69,2.12,1.41,4.3,3.46,4.3s2.76-2.19,3.46-4.3c.28-.85,.78-2.38,1.2-2.74,.42,.36,.92,1.9,1.2,2.74,.69,2.12,1.41,4.3,3.46,4.3s2.76-2.19,3.46-4.3c.28-.85,.78-2.38,1.2-2.74,.42,.36,.92,1.9,1.2,2.74,.7,2.12,1.41,4.3,3.46,4.3s2.76-2.19,3.46-4.3c.28-.85,.78-2.38,1.2-2.74,.42,.36,.92,1.9,1.2,2.74,.7,2.12,1.41,4.3,3.46,4.3s2.76-2.19,3.46-4.3c.28-.85,.78-2.38,1.2-2.74,.42,.36,.92,1.9,1.2,2.74,.7,2.12,1.41,4.3,3.46,4.3s2.76-2.19,3.46-4.3c.28-.85,.78-2.38,1.2-2.74,.42,.36,.92,1.9,1.2,2.74,.7,2.12,1.41,4.3,3.46,4.3s2.76-2.19,3.46-4.3c.28-.84,.78-2.37,1.19-2.74,0,0,.02,.01,.03,.02,.41,.4,.9,1.89,1.18,2.72,.44,1.33,.89,2.69,1.67,3.52,.47,.51,1.05,.82,1.83,.82,2.04,0,2.76-2.19,3.46-4.31,.28-.85,.78-2.38,1.19-2.75,.04,.04,.09,.09,.13,.16,.38,.55,.79,1.81,1.04,2.56,.4,1.21,.8,2.44,1.46,3.27,.5,.65,1.14,1.07,2.03,1.07,2.05,0,2.77-2.19,3.46-4.31,.27-.85,.78-2.38,1.19-2.75,.05,.04,.1,.1,.15,.18,.38,.56,.79,1.8,1.03,2.54,.35,1.07,.71,2.15,1.24,2.97,.52,.82,1.21,1.38,2.24,1.38,2.05,0,2.77-2.19,3.46-4.31,.27-.85,.78-2.38,1.19-2.75,.42,.36,.92,1.9,1.2,2.75,.7,2.12,1.42,4.31,3.46,4.31s2.77-2.19,3.46-4.31c.27-.85,.78-2.38,1.19-2.75,.42,.36,.92,1.9,1.2,2.75,.7,2.12,1.42,4.31,3.46,4.31s2.77-2.19,3.46-4.31c.28-.85,.78-2.38,1.2-2.75,.41,.36,.92,1.9,1.19,2.75,.7,2.12,1.42,4.31,3.46,4.31s2.76-2.19,3.46-4.31c.28-.85,.78-2.38,1.2-2.75,.41,.36,.92,1.9,1.19,2.75,.7,2.12,1.42,4.31,3.46,4.31s2.76-2.19,3.46-4.31c.28-.85,.78-2.38,1.2-2.75,.42,.36,.92,1.9,1.2,2.75,.69,2.12,1.41,4.31,3.46,4.31s2.77-2.19,3.46-4.31c.27-.85,.78-2.38,1.2-2.75,.31,.27,.67,1.19,.95,1.99v-3.97c-.28-.12-.59-.19-.95-.19Z"
					})
				] })
			]
		})
	]
});
export default SvgEmptyStateSchedule;
